import { render, staticRenderFns } from "./UiMatching.vue?vue&type=template&id=39980fdc&"
import script from "./UiMatching.vue?vue&type=script&lang=ts&"
export * from "./UiMatching.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports